import { fetchConToken } from "../helpers/fetch";

const LaboratorioService = {
  getBuscardorPracticasLaboratorioTexto: (texto) => {
    return fetchConToken(`RelCodNomCentroEfector/traerPorTexto?texto=${texto}`);
  },
  getBuscardorPracticasLaboratorioEfectorTexto: (texto, idSolicitud) => {
    return fetchConToken(
      `NomencladorNacional/traerLaboratorioSolicitud?texto=${
        texto
      }&idSolicitud=${
        idSolicitud
      }`
    );
  },
  getSolicitudesLaboratorio: (idAfiliado, idCentroMedico, idEfectorFacturacion) => {
    return fetchConToken(
      `Solicitudes/traerLaboratorio?idAfiliado=${idAfiliado}
      ${!!idCentroMedico ? `&idCentroMedico=${idCentroMedico}` : ""}
      ${!!idEfectorFacturacion ? `&idEfectorFacturacion=${idEfectorFacturacion}` : ""}`
    );
  },
  getPracticasLaboratorio: (data) => {
    return fetchConToken(
      `RelCodNomCentroEfector/traerPorParametros?idEspecialidad=${
        data.idEspecialidad
      }${!!data.idCentroMedico ? `&idCentroMedico=${data.idCentroMedico}` : ""        
      }${!!data.gruposSeleccionados ? `&gruposSeleccionados=${data.gruposSeleccionados}` : ""}
      ${!!data.idEfectorFacturacion ? `&idEfectorFacturacion=${data.idEfectorFacturacion}` : ""}`
    );
  },
  addPracticaLaboratorio: (data) => {
    return fetchConToken(`RelCodNomCentroEfector`, data, "POST");
  },
  deletePracticaLaboratorio: (data) => {
    return fetchConToken(`RelCodNomCentroEfector`, data, "DELETE");
  },
  checkPracticasAutorizacion: (idAfiliado, practicas, idCentroMedico, idEfectorFacturacion) => {
    return fetchConToken(
      `Solicitudes/checkPracticasAutorizacion?idAfiliado=${idAfiliado}&practicas=${practicas}
      ${!!idCentroMedico ? `&idCentroMedico=${idCentroMedico}` : ""}
      ${!!idEfectorFacturacion ? `&idEfectorFacturacion=${idEfectorFacturacion}` : ""}`
    );
  },
  confirmSolicitudLaboratorio: (data) => {
    return fetchConToken(`Solicitudes/generarSolicitudLaboratorio`, data, "POST");
  },
  confirmSolicitudLaboratorioCab: (data) => {
    return fetchConToken(`Solicitudes/generarSolicitudLaboratorioCab`, data, "POST");
  },
  confirmSolicitudAutorizadaLaboratorio: (data) => {
    return fetchConToken(`Solicitudes/confirmarSolicitudAutorizadaLaboratorio`, data, "POST");
  },
};

export { LaboratorioService as default };
